import { Injectable } from '@angular/core';

import { Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';

import { BrokerService, BrokerRequest } from '@c4/core';
import { C4Option } from '@c4/ui';

import { ItemsService } from './../../common/services/items.service';
import { Device } from '../../common/interfaces/item.interface';
import { Command } from '../../common/params/interfaces/command.interface';

export interface ThermostatProgrammingContext {
  thermostats?: Device[];
}

const PROXY_WHITELIST = ['thermostatV2'];

const INITIAL_STATE: ThermostatProgrammingContext = {};

const STORE_NAME = ['PROGRAMMING', 'QUICKSTARTS', 'THERMOSTATS'].join(':');

export const THERMOSTAT_ACTIONS = {
  SET_THERMOSTATS: `${STORE_NAME}:SET_THERMOSTATS`,
  CLEAR: `${STORE_NAME}:CLEAR`
}

const THERMOSTAT_ACTION_STRINGS = Object.keys(THERMOSTAT_ACTIONS).map(key => THERMOSTAT_ACTIONS[key]);

export function thermostatProgrammingReducers(state: ThermostatProgrammingContext = INITIAL_STATE, { type, payload }): ThermostatProgrammingContext {

  // if (THERMOSTAT_ACTION_STRINGS.indexOf(type) > -1) {
  //   console.debug('DEBUG >> %s called with %O', type, payload);
  // }

  switch (type) {
    case THERMOSTAT_ACTIONS.SET_THERMOSTATS:
      return Object.assign({}, state, { thermostats: payload });

    case THERMOSTAT_ACTIONS.CLEAR:
      return Object.assign({}, INITIAL_STATE)

    default:
      return state;
  }
}

@Injectable()
export class QSThermostatService {

  private _subscriptions: Subscription[] = [];

  constructor(
    private _store: Store<{
      thermostatProgramming: ThermostatProgrammingContext
    }>,
    private _items: ItemsService,
    private _broker: BrokerService
  ) {
    this._subscriptions.push(

      this._items.itemsList.map(items => {
        return items.filter((item: Device) => {
          return PROXY_WHITELIST.indexOf(item.proxy) > -1 && item.type === 7
        })
      })
        .subscribe(thermostats => {
          this._store.dispatch({
            type: THERMOSTAT_ACTIONS.SET_THERMOSTATS,
            payload: thermostats
          })
        })
    );
  }

  ngOnDestroy() {
    this._subscriptions.forEach(sub => sub.unsubscribe());
    this._store.dispatch({
      type: THERMOSTAT_ACTIONS.CLEAR
    })
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-thermostats/quickstart-thermostats.service.ts